import React from 'react';
import SectionOne from './SectionOne/SectionOne';
import SectionTwo from './SectionTwo/SectionTwo';
import SectionThree from './SectionThree/SectionThree';

const LandingPage = () => {
	return (
		<div style={{ backgroundColor: '#F1F1F1' }}>
			<SectionOne />
			<SectionTwo />
			<SectionThree />
		</div>
	);
};

export default LandingPage;
